import { useI18n } from "@/i18n/I18nContext";
import { LegalProse } from "@/pages/components/LegalProse";
import { TextPageLayout } from "@/pages/components/TextPageLayout";
import { DocumentHead } from "@/seo/DocumentHead";
import { PAGE_SEO } from "@/seo/pageMeta";

const h2 = "mb-4 text-3xl text-[#111111]";
const h3 = "mb-3 mt-2 text-2xl font-semibold text-[#111111]";

export function PrivacyPolicyPage() {
  const { messages } = useI18n();
  const p = messages.legal.privacy;
  const seo = PAGE_SEO["/privacy-policy"];

  return (
    <TextPageLayout title={p.pageTitle} lastUpdatedLine={p.lastUpdated}>
      <DocumentHead
        title={`${p.pageTitle} — WasOK`}
        description={seo.description}
        path="/privacy-policy"
      />
      <section>
        <h2 className={h2}>{p.introduction.title}</h2>
        <LegalProse text={p.introduction.body} />
      </section>

      <section>
        <h2 className={h2}>{p.dataStored.title}</h2>
        <LegalProse text={p.dataStored.body} />
      </section>

      <section>
        <h2 className={h2}>{p.permissions.title}</h2>
        <h3 className={h3}>{p.permissions.camera.title}</h3>
        <LegalProse text={p.permissions.camera.body} />
        <h3 className={h3}>{p.permissions.photos.title}</h3>
        <LegalProse text={p.permissions.photos.body} />
        <h3 className={h3}>{p.permissions.files.title}</h3>
        <LegalProse text={p.permissions.files.body} />
      </section>

      <section>
        <h2 className={h2}>{p.backup.title}</h2>
        <LegalProse text={p.backup.body} />
        <h3 className={h3}>{p.backup.onlineProductLookup.title}</h3>
        <LegalProse text={p.backup.onlineProductLookup.body} />
      </section>

      <section>
        <h2 className={h2}>{p.advertising.title}</h2>
        <LegalProse text={p.advertising.intro} />
        <h3 className={h3}>{p.advertising.admob.title}</h3>
        <LegalProse text={p.advertising.admob.body} />
        <h3 className={h3}>{p.advertising.crashlytics.title}</h3>
        <LegalProse text={p.advertising.crashlytics.body} />
        <h3 className={h3}>{p.advertising.externalProductDatabases.title}</h3>
        <LegalProse text={p.advertising.externalProductDatabases.body} />
      </section>

      <section>
        <h2 className={h2}>{p.dataSecurity.title}</h2>
        <LegalProse text={p.dataSecurity.body} />
      </section>

      <section>
        <h2 className={h2}>{p.children.title}</h2>
        <LegalProse text={p.children.body} />
      </section>

      <section>
        <h2 className={h2}>{p.notifications.title}</h2>
        <LegalProse text={p.notifications.body} />
      </section>

      <section>
        <h2 className={h2}>{p.yourControl.title}</h2>
        <LegalProse text={p.yourControl.body} />
      </section>

      <section>
        <h2 className={h2}>{p.changes.title}</h2>
        <LegalProse text={p.changes.body} />
      </section>

      <section>
        <h2 className={h2}>{p.contact.title}</h2>
        <LegalProse text={p.contact.body} />
      </section>
    </TextPageLayout>
  );
}
